import TimeStamp from "./TimeStamp";
import IsOnline from "./IsOnline";
import CheckNull from "./CheckNull";
import IsActive from "./IsActive";
import { useEffect, useState } from "react";
import { downloadImage, getImageFileInfo } from "../../../../Api/Network";
import ImagePreviewModal from "../Modal/ImagePreviewModal";

function DetailsUser({ user, close }) {

    const [avatarInfo, setAvatarInfo] = useState(null);
    const [avatarUrl, setAvatarUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const [showImagePreview, setShowImagePreview] = useState(false);

    const handleClose = () => {
        close(false);
    };

    // console.log(user.avatars[0])

    useEffect(() => {
        const fetchAvatar = async () => {
            try {
                setLoading(true);
                if (user?.avatars?.length > 0) {
                    const avatarId = user.avatars[0];
                    const token = localStorage.getItem("token");
                    const fileInfo = await getImageFileInfo(token, avatarId);
                    console.log(fileInfo);
                    const fileSize = fileInfo.fileSize;
                    const imageBlob = await downloadImage(
                        token,
                        avatarId,
                        fileSize
                    );
                    const imageUrl = URL.createObjectURL(imageBlob);
                    setAvatarUrl(imageUrl);
                }

            } catch (error) {
                console.log(error);
            } finally {

                setLoading(false);

            }
        };

        fetchAvatar();

    }, [user]);

    return (
        <>
            <div className="modal-overlay fixed top-0 left-0 w-screen h-screen bg-black opacity-40" onClick={handleClose}></div>
            <div className="fixed top-[48%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg px-20 py-14 ">
                <img src="/image/icon/close.png" className="w-5" onClick={() => close(false)} />
                <p className="text-right text-lg font-bold mb-4">جزئیات</p>
                <div className="flex justify-end mb-6">

                    {
                        loading ? (
                            <div className="w-24 h-24 bg-slate-100 rounded-full p-8">
                                <div className="w-full h-full border-4 border-slate-300 border-t-primary-500 rounded-full animate-spin opacity-50"></div>
                            </div>
                        ) : (

                            avatarUrl && (
                                <img
                                    src={avatarUrl}
                                    alt="avatar"
                                    onClick={() => setShowImagePreview(true)}
                                    className="w-24 h-24 rounded-full object-cover shadow-lg cursor-pointer hover:scale-105 transition"
                                />
                            )

                        )
                    }

                </div>
                <div className="text-right flex flex-row-reverse">
                    <div className="w-40 text-slate-400">
                        <p className="mb-2">: نام</p>
                        <p className="mb-2">: شناسه</p>
                        <p className="mb-2">: شماره موبایل</p>
                        <p className="mb-2">: متن بیوگرافی</p>
                        <p className="mb-2">: نام کاربری</p>
                        <p className="mb-2">: توکن</p>
                        <p className="mb-2">: IP</p>
                        <p className="mb-2">: زمان ایجاد </p>
                        <p className="mb-2">: وضعیت آنلاین بودن</p>
                        <p className="mb-2">: وضعیت فعال بودن</p>
                        <p className="mb-2">: آخرین فعالیت</p>
                        <p className="mb-2">: زمان بروز رسانی</p>
                        {/* <p className="mb-2">: نوع کاربر</p> */}
                        <p className="mb-2">: webHookCallbackUrl</p>
                        <p className="mb-2">: webHookToken</p>
                        <p className="mb-2">: TokenHeader</p>
                    </div>
                    <div>
                        <CheckNull item={user.name} />
                        <CheckNull item={user.id} />
                        <p className="font-bold text-slate-700 mb-2">{user.phoneNumber}</p>
                        <CheckNull item={user.profileText} />
                        <CheckNull item={user.nickName} />   {/* نام کاربری */}
                        <CheckNull item={user.token} />
                        <p
                            className={`text-right mb-2 ${!user.ip ? "text-gray-400" : "text-black"}`}
                        >
                            {user.ip || "ندارد"}
                        </p>
                        <p className="mb-2"><TimeStamp timestamp={user.createdTime} /></p>
                        <p className="mb-2"><IsOnline isOnline={user.isOnline} /></p>
                        <p className="mb-2"><IsActive isActive={user.isActive} /></p>
                        <CheckNull item={user.lastActivityTime} />
                        <p className="mb-2"><TimeStamp timestamp={user.updatedTime} /></p>
                        {/* <CheckNull item={user.userType} /> */}
                        <CheckNull item={user.webHookCallbackUrl} />
                        <CheckNull item={user.webHookToken} />
                        <CheckNull item={user.webHookTokenHeader} />
                    </div>
                </div>
            </div>
            {
                showImagePreview && (
                    <ImagePreviewModal
                        image={avatarUrl}
                        open={showImagePreview}
                        onClose={() => setShowImagePreview(false)}
                    />
                )
            }
        </>
    );
}
export default DetailsUser;
